import { ChakraProvider, type ChakraProviderProps } from '@chakra-ui/react'
import type { FC } from 'react'

import theme from './theme'

export const ThemeProvider: FC<ChakraProviderProps> = ({
  children,
  ...props
}) => {
  return (
    <ChakraProvider resetCSS={false} theme={theme} {...props}>
      {children}
    </ChakraProvider>
  )
}
